import React from 'react';
const CultureGuide: React.FC = () => (
  <div className="min-h-screen bg-white py-12" dir="ltr">
    <div className="max-w-3xl mx-auto bg-rose-50 rounded-xl shadow-lg p-8">
      <h1 className="text-3xl font-bold text-rose-900 mb-6">Cultural Experiences in Iran</h1>
      <p className="text-lg text-gray-700 mb-4">Explore Persian holidays, dress codes, and etiquette for visiting cultural sites.</p>
      {/* Add more content here */}
    </div>
  </div>
);
export default CultureGuide; 